import { render, staticRenderFns } from "./PhoneViewer.vue?vue&type=template&id=545f65f0&scoped=true&"
import script from "./PhoneViewer.vue?vue&type=script&lang=js&"
export * from "./PhoneViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f65f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideXReverseTransition,VSlideXTransition})
